export default "__VITE_ASSET__BqY0hWt0__"